import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { reduxForm, Field, reset, change } from "redux-form";
import { NotificationManager } from "react-notifications";

import { FormField } from "../../../../sharedComponents/formField";
import { getCategoryGroups } from "../../../../store/actions";
import { required } from "../../../../constants/formValidators";

import CategoryGroupListing from "../../categories/CategoryGroupListing";

const SelectCategoryForm = ({
	getCategoryGroups,
	categoryGroupList,
	recipeCategoryList,
	handleSubmit,
	onUpdate,
	resetForm,
	togglePanel,
	submitting,
	change
}) => {
	useEffect(() => {
		getCategoryGroups();
	}, [getCategoryGroups]);

	const [disable, setDisable] = useState(false);

	const renderCategoryList = () => {
		let list = [];
		categoryGroupList &&
			categoryGroupList.length &&
			categoryGroupList.map((item) => {
				return item.group.map((innItem) => {
					return (list = [
						...list,
						{
							groupName: item.name,
							groupId: item.id,
							name: `${item.name} - ${innItem.name}`,
							itemName: innItem.name,
							id: innItem.id
						}
					]);
				});
			});
		return list;
	};

	const list = renderCategoryList();

	const validateForm = (values) => {
		setDisable(true);
		const selectedCategory = list.filter((item) => Number(item.id) === Number(values.category));
		const isExists = recipeCategoryList
			? recipeCategoryList.filter((item) => Number(item.category__id) === Number(values.category)).length > 0
			: false;
		if (isExists) {
			NotificationManager.error("Please select another category!", "", 5000);
		} else {
			onUpdate(selectedCategory[0]);
			resetForm("SelectCategoryForm");
		}
	};

	const [animPanel, setAnimPanel] = useState(1);

	const onBack = (event) => {
		const selectedItem = list.filter(item => event.data.id === item.id);
		selectedItem && selectedItem.length && change('SelectCategoryForm','category', selectedItem[0].id);
		setAnimPanel(event.panel);
	}

	return list && list.length ? (
		<div className="anim-panel">
			<div className={`list-panel panel ${animPanel === 1 ? "active" : ""}`}>
				<form className="flex-fill d-flex flex-column w-100 select-category-wrap h-100" onSubmit={handleSubmit(validateForm)}>
					<div className="flex-fill">
						<h5 className="text-primary-dark mb-2">Add a category</h5>
						<div className="flex-fill">
							<Field
								name="category"
								formGroupClass="m-0"
								type="select"
								options={list}
								component={FormField}
								validate={[required]}
								label="Category"
								selected={91}
								onChange={() => setDisable(false)}
							/>
						</div>
					</div>
					<div className="d-flex align-items-end">
						<div className="flex-fill">
							<h5 className="text-primary-dark mt-3">Cannot find a category?</h5>
							<button type="button" className="btn btn-primary-dark btn-ghost" onClick={() => setAnimPanel(2)}>
								<i className="icon icon-add-edit" /> Edit or Add
					</button>
						</div>
						<div className="text-right">
							<button className="btn btn-default" type="button" onClick={() => togglePanel(false)}>
								Cancel
					</button>
							<button className="btn btn-primary-dark" type="submit" disabled={submitting || disable}>
								Add Now
					</button>
						</div>
					</div>
				</form>
			</div>
			<div className={`add-edit-panel panel ${animPanel === 2 ? "active" : ""}`}>
				<CategoryGroupListing onBack={onBack} />
			</div>
		</div>
	) : null;
};

const mapStateToProps = (state) => {
	return {
		categoryGroupList: get(state, "AddRecipe.categoryGroupList.results", [])
	};
};

const mapDispatchToProps = {
	getCategoryGroups,
	resetForm: reset,
	change
};

export default reduxForm({
	form: "SelectCategoryForm",
	enableReinitialize: true
})(connect(
	mapStateToProps,
	mapDispatchToProps
)(SelectCategoryForm)
);
